"use strict";
/* eslint-disable */
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));
var _default = exports.default = (0, _createIcon.default)( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M21.463 10.392h-.757v-.04h-8.47v3.766h5.32a5.648 5.648 0 0 1-5.32 3.764 5.646 5.646 0 0 1-5.648-5.647 5.646 5.646 0 0 1 5.647-5.647c1.44 0 2.75.542 3.747 1.43l2.661-2.661a9.367 9.367 0 0 0-6.408-2.534 9.411 9.411 0 0 0-9.412 9.412 9.411 9.411 0 0 0 9.412 9.412 9.411 9.411 0 0 0 9.228-11.255Z",
  fill: "#FFC107"
}), /*#__PURE__*/React.createElement("path", {
  d: "m3.908 7.855 3.094 2.268a5.644 5.644 0 0 1 5.233-3.535c1.44 0 2.75.542 3.747 1.43l2.661-2.661a9.367 9.367 0 0 0-6.408-2.534 9.406 9.406 0 0 0-8.327 5.032Z",
  fill: "#FF3D00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.235 21.647c2.43 0 4.64-.93 6.311-2.443l-2.914-2.465a5.609 5.609 0 0 1-3.397 1.143 5.643 5.643 0 0 1-5.309-3.739l-3.07 2.364c1.558 3.048 4.721 5.14 8.38 5.14Z",
  fill: "#4CAF50"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.463 10.392h-.757v-.04h-8.47v3.766h5.32a5.674 5.674 0 0 1-1.926 2.621h.002l2.914 2.465c-.206.186 3.101-2.263 3.101-6.969 0-.63-.064-1.246-.184-1.843Z",
  fill: "#1976D2"
})), "0 0 24 24", "Google");